import { BookingSiteSocials, SOCIAL_NORMALIZERS } from '@porter/shared-theme';

const FIELDS = Object.keys(SOCIAL_NORMALIZERS) as (keyof BookingSiteSocials)[];

/**
 * Every rejection reads `<field> must ...`, which is matched wherever it sits
 * rather than at the head: the API joins class-validator's array into one
 * string before it leaves, so only the first refused field is ever at a head.
 * `must` is what keeps a message that merely mentions a field from claiming it.
 */
const names = (field: string) => new RegExp(`\\b${field} must\\b`);

/**
 * Which links the API refused, so a refused link says so on its own input
 * instead of in a toast that does not say which one.
 */
export function rejectedSocials(error: unknown): (keyof BookingSiteSocials)[] {
  const data = (
    error as { response?: { data?: { message?: unknown } } } | undefined
  )?.response?.data;
  const message = [data?.message ?? []]
    .flat()
    .filter((part): part is string => typeof part === 'string')
    .join(' ');

  return FIELDS.filter(field => names(field).test(message));
}
